if (typeof JW === 'undefined') JW = {};
JW.MapList = (function ($)
{
    var _pri = {opts:{}};
    var publ = {};

    _pri.cname  = 'MAPLIST';
    _pri.inited = false;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.initVals = function()
    {
        _pri.opts = $.extend(_pri.opts, {
                                get_jobs_url: '/_jsl' // jobs list url
                            });

        _pri.page = null;
        _pri.$cont = null;
        _pri.$col = null;
        _pri.html_load = '<i class="fa fa-refresh fa-spin fa-fw" aria-hidden="true"></i> Anbieter werden geladen';
        _pri.$btn_nxt = null;
        _pri.$jcnt = null;

        _pri.jobs      = [];
        _pri.jobs_meta = {};
        _pri.jobs_len  = 0;
        _pri.page_cur  = 0;
        _pri.page_size = 25;

        _pri.scroll_top = 0;

        _pri.$cont    = $('#jsl');
        _pri.$col     = $('#col-right');
        _pri.$jcnt    = $('#jcnt');
        _pri.$btn_nxt = $('#btn-nxt');

        if (_pri.$jcnt.length > 0)
        {
            _pri.jcnt_cntsfx = _pri.$jcnt.data('cntsfx');
        }
        else
        {
            _pri.jcnt_cntsfx = ' Unternehmen gefunden';
        }

    };

    publ.init = function()
    {
        _pri.dbgG('*** init()');

        if (_pri.inited)
        {
            _pri.dbgB('    already inited');
            // return;
        }

        _pri.initVals();

        _pri.page = JW.Page;

        if (_pri.$cont.length == 0)
        {
            _pri.dbg('    no #jsl - exit');
            return;
        }

        _pri.initOpts();
        _pri.initEvs();

        _pri.inited = true;
        _pri.page.trigger('module:init_done', {mod: _pri.cname});
    };

    publ.showCol = function(bool)
    {
        //_pri.dbg('******** showCol(' + bool + ')');
        if (!_pri.$col)
        {
            return;
        }

        if (!_pri.$col.hasClass('d-none'))
        {
            if (_pri.page.isPhoneMode())
            {
                _pri.scroll_top = $(window).scrollTop();
            }
            else
            {
                _pri.scroll_top = _pri.$col.scrollTop();
            }
            //_pri.dbg('_pri.scroll_top: ' + _pri.scroll_top);
        }

        if (bool)
        {
            //_pri.dbg('######## show, scroll_top: '+_pri.scroll_top);
            _pri.$col.removeClass('d-none');
            if (_pri.page.isPhoneMode())
            {
                //_pri.dbg('    window scroll');
                $(window).scrollTop(_pri.scroll_top);
            }
            else if (_pri.scroll_top > 50)
            {
                //_pri.dbg('    col scroll');
                _pri.$col.scrollTop(_pri.scroll_top - 50);
            }
        }
        else
        {
            _pri.$col.addClass('d-none');
        }
    };

    _pri.setJobs = function(key)
    {
        var ret = JW.MapSForm.getJobsToKey(key);
        //_pri.dbg(typeof ret);
        _pri.dbg('ret', ret);
        if (_pri.isObj(ret) && _pri.isObj(ret.jobs) && $.isArray(ret.jobs))
        {
            _pri.$btn_nxt.hide();
            _pri.jobs = ret.jobs; //.slice(0);
            _pri.jobs_len = _pri.jobs.length;
            _pri.jobs_meta =
            {
                lat: ret.lat,
                lng: ret.lng,
                dst: ret.dst
            };
            _pri.$jcnt.html(_pri.jobs_len + _pri.jcnt_cntsfx);
            _pri.page_cur = 0;
            _pri.$cont.html('');
            _pri.nextPage();
        }
    };

    _pri.nextPage = function()
    {
        //UPDATE jobs SET prio = 100 WHERE prio = 0 AND RAND() < 0.05
        var ids = [];
        var i = _pri.page_cur * _pri.page_size;
        var imx = i + _pri.page_size;
        for (i; i < imx; ++i)
        {
            if (_pri.jobs[i] && typeof _pri.jobs[i] === 'object')
            {
                ids.push(_pri.jobs[i][0]);
            }
        }

        _pri.page_cur++;

        var form_data = {ids: ids.join(',')};
        form_data = $.extend(form_data, _pri.jobs_meta);

        $.ajax({
            type: "POST",
            url: _pri.opts.get_jobs_url + '?tkn=' + JW.Page.getUId(32),
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            data: form_data,
            dataType: 'html'
        }).done(function(ret, stat_str, jq_xhr) {
            _pri.dbg('*** nextPage() done');
            _pri.$cont.append(ret);
            _pri.$cont.find('.rating-list-wrp').find('input').rating(_pri.opts.list_rating);

            _pri.showBtnNxt();
        });
    };

    _pri.showBtnNxt = function()
    {
        _pri.dbg('******** showBtnNxt() len: ', _pri.jobs_len, ' cur: ', (_pri.page_cur * _pri.page_size));
        if (_pri.page_cur * _pri.page_size < _pri.jobs_len)
        {
            _pri.$btn_nxt.show();
        }
        else
        {
            _pri.$btn_nxt.hide();
        }
    };

    _pri.initEvs = function()
    {
        if (!_pri.inited)
        {
            _pri.page.on('sform:loading_jobs', function(e) {
                _pri.$jcnt.html(_pri.html_load);
                _pri.$cont.html('');
            });

            _pri.page.on('sform:loading_jobs_done', function(e, o) {
                // stop loading indicator
                _pri.dbg('e', e);
                _pri.dbg('o.key', o.key);
                _pri.setJobs(o.key);
            });

            $(document).on('click', '.lnk-loc', function(e, o) {
                e.stopPropagation();
                e.preventDefault();
                var id = $(this).closest('.job-crd').data('id');
                _pri.dbg('*** .lnk-loc.click() id:', id);
                if (_pri.page.isPhoneMode())
                {
                    JW.MapSForm.ffxClick('#col-map');
                }
                _pri.page.trigger('map_list:loc_click', id);
            });
        }

        _pri.$btn_nxt.click(_pri.nextPage);
        _pri.$btn_nxt.hide();
    };

    _pri.initOpts = function()
    {
        _pri.opts.list_rating = {
            theme: '',
            emptyStar: '<i class="glyphicon glyphicon-star"></i>',
            language: 'de',
            displayOnly: true,
            size: 'xs'
        }
    }

    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);